import { Logger as PayseraLogger, ConsoleProvider } from '@paysera/paysera-logger';
import Raven from 'raven-js';
import RavenProvider from './RavenProvider';

export default function (loggerName = null) {
    const logger = new PayseraLogger();

    if (process.env.NODE_ENV === 'production') {
        logger.addProvider(new RavenProvider(Raven, loggerName));
    } else {
        logger.addProvider(new ConsoleProvider());
    }

    return logger;
}
